export default "__VITE_ASSET__eb8f6fec__"